export default __webpack_public_path__ + "static/media/080_finish_good.first.b4ebb3e6.png";